import React, { useState, useEffect } from 'react';

const toHHMM = (date) => {
  const d = new Date(date);
  if (isNaN(d)) return '';
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

const Horarios = ({ onChange, startDate, endDate, initialStartDate, initialEndDate }) => {
  const [times, setTimes] = useState({
    startTime: initialStartDate ? toHHMM(initialStartDate) : '',
    endTime: initialEndDate ? toHHMM(initialEndDate) : ''
  });

  const getFullTimestamp = (date, timeStr) => {
    if (!date || !timeStr) return null;
    const [hours, minutes] = timeStr.split(':').map(Number);
    const timestamp = new Date(date);
    timestamp.setHours(hours, minutes, 0, 0);
    return timestamp;
  };

  const notifyChange = (newTimes) => {
    if (newTimes.startTime && newTimes.endTime && startDate && endDate) {
      const startTimestamp = getFullTimestamp(startDate, newTimes.startTime);
      const endTimestamp = getFullTimestamp(endDate, newTimes.endTime);

      onChange({
        startTime: newTimes.startTime,
        endTime: newTimes.endTime,
        isValid: startTimestamp && endTimestamp && endTimestamp > startTimestamp
      });
    } else {
      onChange({
        startTime: newTimes.startTime,
        endTime: newTimes.endTime,
        isValid: false
      });
    }
  };

  // avisar a padre que el valor ha cambiado, hidratar el estado
  useEffect(() => {
    if (initialStartDate && initialEndDate) {
      const hydrated = { startTime: toHHMM(initialStartDate), endTime: toHHMM(initialEndDate) };
      setTimes(hydrated);
      notifyChange(hydrated);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialStartDate, initialEndDate, startDate, endDate]);

  const handleTimeChange = (field, value) => {
    const newTimes = { ...times, [field]: value };
    setTimes(newTimes);
    notifyChange(newTimes);
  };

  const isValidTimeRange = () => {
    if (!times.startTime || !times.endTime || !startDate || !endDate) return true;
    
    const startTimestamp = getFullTimestamp(startDate, times.startTime);
    const endTimestamp = getFullTimestamp(endDate, times.endTime);
    
    return startTimestamp && endTimestamp && endTimestamp > startTimestamp;
  };


  const containerStyle = {
    position: 'relative',
    width: '100%',
    maxWidth: '645px',
    paddingTop: '30px',
    marginTop: '30px',
    marginLeft: 'auto',
    marginRight: 'auto',
  };

  const titleStyle = {
      position: 'absolute',
    top: '0',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: '#1AA29B',
    borderRadius: '40px',
    padding: '10px 30px',
    zIndex: 10,
    minWidth: '200px'
  };

  const contentStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderRadius: '50px',
    padding: '40px 5vw 32px 5vw',
    width: '100%',
    boxSizing: 'border-box',
  };

  return (
    <div style={containerStyle}>
      <div style={titleStyle}>
        <h2 className="text-xl font-semibold text-white text-center uppercase" style={{fontSize: "2.2rem", margin: 0}}>
          Horarios
        </h2>
      </div>

      <div style={contentStyle}>
        <div className="space-y-8">
          <div className="time-input-group">
            <label className="block text-sm font-medium mb-3 uppercase" style={{fontSize: "1.2rem"}}>
              <b>Retiro:</b> {startDate && (
                  new Date(startDate).toLocaleDateString('es-ES', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })
              )}
            </label>
            <div className="relative" style={{ textAlign:'center' }}>
              <input
                type="time"
                value={times.startTime}
                onChange={(e) => handleTimeChange('startTime', e.target.value)}
                className="w-full px-6 py-4 border-2 border-[#1AA29B] rounded-[40px] focus:ring-2 focus:ring-[#1AA29B] focus:border-[#1AA29B] transition-colors text-lg"
                step="300"
                style={{
                  position: 'relative',
                  width: '100%',
                  maxWidth: '300px',
                  minWidth: '120px',
                  textAlign: 'center',
                  height: '40px',
                  fontSize: '1.1rem',
                }}
              />
            </div>
          </div>

          <div className="time-input-group">
            <label className="block text-sm font-medium mb-3 uppercase" style={{fontSize: "1.2rem"}}>
              <b>Devolución:</b> {endDate && (
                  new Date(endDate).toLocaleDateString('es-ES', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })
              )}
            </label>
            <div className="relative" style={{ textAlign:'center' }}>
              <input
                type="time"
                value={times.endTime}
                onChange={(e) => handleTimeChange('endTime', e.target.value)}
                className="w-full px-6 py-4 border-2 border-[#1AA29B] rounded-[40px] focus:ring-2 focus:ring-[#1AA29B] focus:border-[#1AA29B] transition-colors text-lg"
                step="300"
                style={{
                  position: 'relative',
                  width: '100%',
                  maxWidth: '300px',
                  minWidth: '120px',
                  textAlign: 'center',
                  height: '40px',
                  fontSize: '1.1rem',
                }}
              />
            </div>
          </div>

          {!isValidTimeRange() && (
            <div className="text-red-500 text-sm bg-red-50 p-4 rounded-[40px] text-center">
              El período seleccionado debe comenzar antes de que termine
            </div>
          )}
        </div>
        <style>{`
          @media (max-width: 600px) {
            .time-input-group label {
              font-size: 1rem !important;
            }
            .time-input-group input[type="time"] {
              max-width: 100% !important;
              min-width: 0 !important;
              font-size: 1rem !important;
              height: 38px !important;
            }
            h2 {
              font-size: 1.3rem !important;
              padding: 0.5em 0.2em !important;
            }
            div[style*="border-radius: 50px"] {
              padding: 20px 2vw 16px 2vw !important;
              border-radius: 30px !important;
            }
            div[style*="position: absolute"] {
              min-width: 120px !important;
              width: 95vw !important;
              max-width: 98vw !important;
              padding: 8px 0.5em !important;
            }
            div[style*="position: relative"][style*="max-width: 645px"] {
              padding-top: 15px !important;
              margin-top: 10px !important;
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Horarios;
